import { render, staticRenderFns } from "./ListGifts.vue?vue&type=template&id=e930fd36&scoped=true"
import script from "./ListGifts.vue?vue&type=script&lang=js"
export * from "./ListGifts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e930fd36",
  null
  
)

export default component.exports